import { GET_USER_LOCATION_SUCCESS } from '../actions/userLocationAction'
export default (state = null, { type, data = {} }) => {
  switch (type) {
    case GET_USER_LOCATION_SUCCESS: {
        return data
    }
    default:
      return state
  }
}